import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import { getToken } from '../auth/auth'

const httpLink = new HttpLink({
  uri: 'https://api.graph.cool/simple/v1/cjjzj8f163ynl0114nankeuvw',
})

const authLink = setContext((_, { headers }) => {
  const token = getToken()
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})

export default client



// WEBPACK FOOTER //
// ./src/modules/bootstrap/apolloClient.js